import Spacer from './Spacer';

export default Spacer;



// WEBPACK FOOTER //
// ./src/components/FormElements/Spacer/index.js